<template>
    <v-container>
        <v-row>
            <v-col>
                <v-data-table
                        :headers="headers"
                        :items="items"
                        sort-by="calories"
                        class="elevation-1"
                        v-if="items"
                >
                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-toolbar-title>My CRUD</v-toolbar-title>
                            <v-divider
                                    class="mx-4"
                                    inset
                                    vertical
                            ></v-divider>
                            <v-spacer></v-spacer>
                            <v-dialog v-model="dialog" max-width="500px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                            color="primary"
                                            dark
                                            class="mb-2"
                                            v-bind="attrs"
                                            v-on="on"
                                    >New Item</v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" class="py-0">
                                                    <v-text-field outlined v-model="editedItem.name" label="Name"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6"  class="py-0">
                                                    <v-text-field outlined v-model="editedItem.style" label="Style"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6"  class="py-0">
                                                    <v-select outlined item-text="name" item-value="uuid" label="festivals"  v-model="editedItem.festivalId" :items="festivals" />
                                                </v-col>
                                                <v-col cols="12" sm="6"  class="py-0" >
                                                    <v-text-field outlined v-model="editedItem.section" label="Section"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6"  class="py-0">
                                                    <v-text-field outlined v-model="editedItem.topic" label="Topic"></v-text-field>
                                                </v-col>
                                                <v-col cols="12"  class="py-0">
                                                    <v-textarea outlined v-model="editedItem.body" label="Body"></v-textarea>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                                        <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon
                                small
                                class="mr-2"
                                @click="editItem(item)"
                        >
                            mdi-pencil
                        </v-icon>
                        <v-icon
                                small
                                @click="deleteItem(item)"
                        >
                            mdi-delete
                        </v-icon>
                    </template>
                    <template v-slot:no-data>
                        <v-btn color="primary" @click="initialize">Reset</v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>

</template>

<script>
  import{
    mapState,
    mapActions
  } from 'vuex'
  export default {
    data: () => ({
      dialog: false,
      headers: [
        { text: 'id', value: 'id'},
        { text: 'style', value: 'style'},
        // { text: 'orgkey', value: 'orgkey'},
        { text: 'festivalId', value: 'festivalId'},
        { text: 'name', value: 'name'},
        { text: 'section', value: 'section'},
        { text: 'topic', value: 'topic'},
        { text: 'body', value: 'body'},
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      festivals:[],
      items: [],
      editedIndex: -1,
      editedItem: {
        style:'',
        name: '',
        festivalId: 0,
        section: 0,
        topic: 0,
        body: 0,
      },
      defaultItem: {
        style:'',
        name: '',
        festivalId: 0,
        section: 0,
        topic: 0,
        body: 0,
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
      ...mapState(['icons','org']),
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      ...mapActions(['post','get','put','delete']),
      async initialize () {
        this.items = await this.get({path:'api/faq/all'})
        let data = await this.get({path:'api/event/myfestivals'})
        data.unshift({name:"All Events",uuid:undefined})// this will handle front end. kind of risky
        this.festivals = data
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.items.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.items.splice(index, 1)
        this.delete({path:'api/faq',body:item})
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      async save () {
        let res = await this.post({path:'api/faq',body:this.editedItem})
        if (this.editedIndex > -1) {
          Object.assign(this.items[this.editedIndex], this.editedItem)
        } else {
          this.editedItem.id = res[0]
          this.items.push(this.editedItem)
        }
        this.close()
      }
    },
  }
</script>

<style scoped>

</style>